<template>
  <div id="app">
    <!-- <el-header>
      <div class="common-header">
        <img src="@/assets/jiudouLogo.png" alt="" />
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleSelect"
        >
          <el-menu-item index="index">首页</el-menu-item>
          <el-menu-item index="competitionNavigation">竞赛导航</el-menu-item>
          <el-menu-item index="competitionService">竞赛咨询</el-menu-item>
        </el-menu>
        <div></div>
      </div>
    </el-header> -->
    <main class="app-main">
      <RouterView />
    </main>
    <!-- <webFooter></webFooter> -->
  </div>
</template>

<script>
// import webFooter from "./views/components/footer.vue";
export default {
  name: "App",
  components: {
    // webFooter,
  },
  data() {
    return {
      activeIndex: "",
    };
  },
  watch: {
    $route(to) {
      if (to.name.indexOf("competitionNavigation") !== -1) {
        this.activeIndex = "competitionNavigation";
      } else if (to.name.indexOf("competitionService") !== -1) {
        this.activeIndex = "competitionService";
      } else {
        this.activeIndex = "index";
      }
    },
  },
  mounted() {},
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      if (this.$route.name == key) {
        return;
      }
      this.$router.push("/" + key);
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  background: #f4f7fc;
  // min-width: 1280px;
}

* {
  -webkit-tap-highlight-color: transparent; /* 禁用安卓点击高亮 */
  tap-highlight-color: transparent;
}

#app > .el-header {
  background: rgba(6, 1, 23, 0.3);
  padding: 0;
  // position: absolute;
}
.app-main {
  // min-height: calc(100vh - 58px);
  min-height: calc(100vh - 0px);
  display: flex;
  justify-content: center !important;
}
.common-header {
  display: flex;
  align-items: center;
  .el-menu {
    background: transparent;
    .el-menu-item {
      font-size: 16px;
      background: transparent !important;
      &:hover {
        background: transparent !important;
      }
    }
  }
  img {
    margin: 0 72px;
  }
  .el-menu-demo {
    margin-left: 84px;
  }
}
body {
  margin: 0;
}
</style>
